import React from 'react';

import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import qs from 'query-string';

import image from 'assets/images/merchant-login.png';
import PageTitle from 'modules/common/components/PageTitle';
import Brand from 'modules/partial/components/Brand';
import Footer from 'modules/partial/components/Footer';
import ScreenLoader from 'modules/common/components/ScreenLoader';

import ResetPasswordForm from '../forms/ResetPasswordForm';
import TokenExpired from '../components/TokenExpired';
import { useGetTokenExpiry } from '../hooks';

function ResetPassword() {
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  const query = qs.parse(location?.search) || {};
  const token = query?.token;

  const [tokenExpired, setTokenExpired] = React.useState(false);

  const [isApiLoading] = useGetTokenExpiry(token, null, (err) => {
    const { response } = err;

    if (response?.error === 'token_expired') {
      setTokenExpired(true);

      setTimeout(() => {
        history.push('/merchant-login');
      }, 4000);
    }
  });

  React.useEffect(() => {
    if (!token) history.push('/forgot-password');
  }, [token, history]);

  if (isApiLoading) return <ScreenLoader />;

  return tokenExpired ? (
    <TokenExpired />
  ) : (
    <>
      <PageTitle title="PEP | Reset Password" />

      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="w-full min-h-screen flex relative">
          <div className="m-auto py-6 w-full">
            <div className="flex flex-col justify-center px-8 max-w-lg mx-auto">
              <Brand className="w-auto h-10 mx-auto" url={match?.url} />
              <div className="text-left mt-10 mb-6">
                <h4 className="text-xl text-primary-500 font-semibold">
                  Reset Password,
                </h4>
                <p className="text-sm text-secondary-500 text-opacity-75 font-light">
                  Enter your new password
                </p>
              </div>
              <ResetPasswordForm
                token={token}
                setTokenExpired={setTokenExpired}
              />
            </div>
          </div>
          <div className="absolute bottom-4 px-12 w-full flex justify-center lg:justify-start">
            <Footer />
          </div>
        </div>
        <div
          className="w-full min-h-screen bg-gray-200 hidden md:block bg-no-repeat bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
        />
      </div>
    </>
  );
}

ResetPassword.propTypes = {};

export default ResetPassword;
